/**
 * Constants related to Visibility and Roles
 */
export const VISIBILITY_ALL = 'all'
export const VISIBILITY_NOT_LOGGED = 'not-logged'
export const VISIBILITY_LOGGED_IN = 'logged-in'
export const ROLE_TYPE_ALLOW_ALL = 'allow_all'
export const ROLE_TYPE_ALLOW_EXCEPT = 'allow_all_except'
export const ROLE_TYPE_DISALLOW_EXCEPT = 'disallow_all_except'
export const DEFAULT_USER_ROLE_PREFIX = '__user_source_'
